import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { oktaSigninApi, entraSigninApi } from "../../../services/api";
import { setSnackbar } from "../../../redux/messageSlice";
import { showSnackBar } from "../../../utils/commonServices";
import { gaEvents } from "../../../ga/actions";
import { getPermissions } from "../../../commonactions/actions";
import { updateState } from "../../../redux/commonSlice";
import { updateAppleSignState } from "../../../redux/appleSignSlice";
import { updatePendingCallState } from "../../../redux/pendingCallSlice";
import { setAssetState } from "../../../redux/assetSlice";
import { getTheme } from "../../whitelabel/actions";
import { encryptString } from "../../../utils/encryptionServices";

export default ()=> {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const appleSignReducer = useSelector((state) => state.appleSignReducer);

    ////////////////////////////Auth API for OKTA users /////////////////////////////////////

    const oktaSignin = (payload, callback ) => {
    //const payload = values  
    oktaSigninApi(payload) 
    .then((response) => {
     
        const responseObject = response?.data;
    const responseData = responseObject?.data
    if (responseObject?.http_code == 200) {

      gaEvents.loginEvent()


      if (appleSignReducer.is_redirected_from_butterfly && window.localStorage.getItem('logout_all') !== 'true') {
        dispatch(updateAppleSignState({ is_redirected_from_butterfly: false }))
        dispatch(updatePendingCallState({ redirect_backdrop_open: true }))
        // window.location.href = `http://localhost:3001`;
        const encryptedToken = encryptString(responseData?.token);
        const encodedURIString = encodeURIComponent(encryptedToken);
       
        window.location.href = `${process.env.REACT_APP_COPILOT_URL}/redirect/${encodedURIString}`;
        window.localStorage.setItem("token", responseData?.token);
      } else {
        // dispatch(updateState({is_logged:true}))
        // 
        window.localStorage.setItem("token", responseData?.token);
        window.localStorage.setItem("analytics_access", responseData?.analytics_access ? "true" : "false");
        getPermissions(dispatch)
        getTheme(dispatch)
       // setSigninStatus("success");
        window.localStorage.removeItem('logout_all')
        dispatch(updateState({logout_all: false}))
        navigate("/dashboard", { replace: true });
      }

      dispatch(
        updateState({
          // is_logged: true,
          user_name: responseData?.name,
          user_id: responseData?.user_id,
          company_name: responseData?.company_name,
          show_revision_tutorial: responseData?.show_revision_tutorial,
          is_company_name_available: responseData?.company_name ? true : false,
          signin_loading: false,
          approver_allowed:  responseData?.approver_allowed,
          analytics_access: !!responseData?.analytics_access,
          ...(responseData?.sso_managed !== undefined && { sso_managed: responseData.sso_managed }),
          ...(responseData?.scim_managed !== undefined && { scim_managed: responseData.scim_managed }),
        })
      );

      dispatch(setAssetState({
        is_brand_name_available: responseData?.company_name ? true : false,
      }))
      dispatch(updatePendingCallState({ redirect_backdrop_open: false }))




      // navigate("/", {replace: true});



    

      }else {
          callback(false)
          dispatch(setSnackbar({type:'error', flag:true, message: 'some error occured'}))
      }
    })
    .catch((error) => {
        callback(false)
        const errorObject = error?.response?.data;
        if(errorObject.data && errorObject.data.email_verified == false){
         // setSigninStatus("unverified");
        } else{
          //setSigninStatus("error");
          gaEvents.loginFailed()
          showSnackBar(dispatch, errorObject)
        }
    });
  }
  
  ////////////////////////////Auth API for Entra ID users /////////////////////////////////////

    const entraSignin = (payload, callback) => {
    entraSigninApi(payload)
    .then((response) => {
        const responseObject = response?.data;
        const responseData = responseObject?.data;
        if (responseObject?.http_code == 200) {

          gaEvents.loginEvent()

          if (appleSignReducer.is_redirected_from_butterfly && window.localStorage.getItem('logout_all') !== 'true') {
            dispatch(updateAppleSignState({ is_redirected_from_butterfly: false }))
            dispatch(updatePendingCallState({ redirect_backdrop_open: true }))
            const encryptedToken = encryptString(responseData?.token);
            const encodedURIString = encodeURIComponent(encryptedToken);
            window.location.href = `${process.env.REACT_APP_COPILOT_URL}/redirect/${encodedURIString}`;
            window.localStorage.setItem("token", responseData?.token);
          } else {
            window.localStorage.setItem("token", responseData?.token);
            window.localStorage.setItem("analytics_access", responseData?.analytics_access ? "true" : "false");
            getPermissions(dispatch)
            getTheme(dispatch)
            window.localStorage.removeItem('logout_all')
            dispatch(updateState({logout_all: false}))
            navigate("/dashboard", { replace: true });
          }

          dispatch(
            updateState({
              user_name: responseData?.name,
              user_id: responseData?.user_id,
              company_name: responseData?.company_name,
              show_revision_tutorial: responseData?.show_revision_tutorial,
              is_company_name_available: responseData?.company_name ? true : false,
              signin_loading: false,
              approver_allowed: responseData?.approver_allowed,
              analytics_access: !!responseData?.analytics_access,
              ...(responseData?.sso_managed !== undefined && { sso_managed: responseData.sso_managed }),
              ...(responseData?.scim_managed !== undefined && { scim_managed: responseData.scim_managed }),
            })
          );

          dispatch(setAssetState({
            is_brand_name_available: responseData?.company_name ? true : false,
          }))
          dispatch(updatePendingCallState({ redirect_backdrop_open: false }))

        } else {
          callback(false)
          dispatch(setSnackbar({type:'error', flag:true, message: 'some error occured'}))
        }
    })
    .catch((error) => {
        callback(false)
        const errorObject = error?.response?.data;
        const status = error?.response?.status;
        if (status === 401) {
          dispatch(setSnackbar({type:'error', flag:true, message: 'Session expired. Please sign in again from your Entra portal.'}))
        } else {
          gaEvents.loginFailed()
          showSnackBar(dispatch, errorObject)
        }
    });
  }

  return {oktaSignin, entraSignin}

}